<template>
  <div>
    <SingleColArticleList v-if="showType === 'single'" :brand-id="brandId" :list="list" :tjjj-prefix="tjjjPre" />
    <HotList v-if="showType === 'multi'" :brand-id="brandId" :hot-list="list" :tjjj-prefix="tjjjPre" />
  </div>
</template>
<script>
import Vue from 'vue';
import { Toast } from 'vant';
import axios from 'axios';
import HotList from './HotList.vue';
import SingleColArticleList from './SingleColArticleList.vue';

Vue.use(Toast);

const failText = '获取推荐列表异常';

export default {
  name: 'NewRecommendList',
  components: {
    HotList,
    SingleColArticleList,
  },
  props: {
    brandId: {
      type: Number,
      default: -1,
      required: false,
    },
    articleType: {
      type: String,
      default: '',
      required: false,
    },
    zixunId: {
      type: Number,
      default: -1,
      required: false,
    },
    biArticleType: {
      type: String,
      default: '',
      required: false,
    },
    tjjjPrefix: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      initStatus: -1,
      showType: 'multi',
      tjjjPre: '',
    };
  },
  watch: {
    brandId: '_initData',
  },
  mounted() {
    this.$nextTick(() => {
      this._initData();
    });
  },
  methods: {
    _validata() {
      if (this.brandId >= 0 && this.zixunId >= 0) return true;
      return false;
    },
    _initData() {
      if (!this._validata()) return;
      if (this.initStatus !== -1) return;
      const { articleType } = this;
      if (articleType === 'EVALUAT') {
        this.showType = 'single';
        this.tjjjPre = `${this.tjjjPrefix}${articleType}_`;
      }
      this.initStatus = 0;
      const excludeIds = [];
      excludeIds.push(this.zixunId);
      axios.post(`${globalRootUrl}brandhall/recommend/bi/list`, {
        brandId: this.brandId,
        zixunId: this.zixunId,
        excludeIds,
        pageSize: 4,
      })
        .then((res) => {
          const { data } = res;
          if (!data || !data.articles) throw new Error('推荐列表异常');
          this.list = data.articles;
          if (data.articles.length > 0) {
            this.$emit('has-data');
          }
        }).catch((err) => {
          console.warn(err);
          Toast.fail(failText);
        });
    },
  },
};
</script>
